import React, { useRef, useState } from 'react';

import { Box, Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { getCategoryOptions, getSubcategoryOptions } from '../../constants/observationCategories';
import LoadingButton from '../common/LoadingButton';
import SelectField from '../common/NewSelectField';

const useStyles = makeStyles(() => ({
  buttonsContainer: {
    display: 'flex',
    gap: 16,
    justifyContent: 'flex-end',
    marginTop: 24,
    width: '100%',
  },
  cancelButton: {
    borderRadius: '4px',
    color: '#42526E',
    flex: '1',
    fontWeight: '500',
    textTransform: 'none',
  },
  container: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    overflow: 'hidden',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    marginBottom: 12,
    marginRight: '-16px',
    marginTop: 16,
    overflowY: 'auto',
    paddingRight: 16,
    width: 'min(100%, 400px)',
  },
  label: {
    fontWeight: 'bold',
    marginBottom: 8,
  },
  submitButton: {
    '&:hover': {
      backgroundColor: '#2D95C4',
    },
    backgroundColor: '#36B2EC',
    borderRadius: 4,
    color: 'white',
    flex: '1',
    fontWeight: 500,
    textTransform: 'none',
  },
  subtitle: {
    color: '#6B778C',
    fontSize: 14,
    textAlign: 'center',
  },
  title: {
    color: '#172B4D',
    fontSize: 24,
    fontWeight: 600,
    marginBottom: 8,
    textAlign: 'center',
  },
}));

const EditCategoryForm = ({ onSaveCategory, defaultData = {}, isSubmitting, onCancel }) => {
  const classes = useStyles();
  const categoryRef = useRef();
  const subcategoryRef = useRef();
  const [selectedCategory, setSelectedCategory] = useState(defaultData.category || '');
  const [selectedSubcategory, setSelectedSubcategory] = useState(defaultData.subcategory || '');

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setSelectedSubcategory(''); // Reset subcategory when category changes

    // Clear subcategory field
    if (subcategoryRef.current) {
      setTimeout(() => {
        subcategoryRef.current.setValue('');
      }, 100);
    }
  };

  const handleSubcategoryChange = (subcategory) => {
    setSelectedSubcategory(subcategory);
  };

  const onSaveClick = () => {
    const categoryData = {
      category: selectedCategory || null,
      subcategory: selectedSubcategory || null,
    };
    onSaveCategory(categoryData);
  };

  return (
    <>
      <div className={classes.container}>
        <div className={classes.header}>
          <Typography variant="h4" className={classes.title}>
            Edit Issue Category
          </Typography>
          <Typography variant="body1" className={classes.subtitle}>
            Update the AI-generated category and subcategory for this observation
          </Typography>
        </div>

        <div className={classes.formContainer}>
          <Box>
            <Typography className={classes.label}>Category</Typography>
            <SelectField
              ref={categoryRef}
              name="category"
              items={getCategoryOptions()}
              placeholder="Select Category"
              value={selectedCategory || ''}
              onChange={handleCategoryChange}
            />
          </Box>

          {selectedCategory && (
            <Box>
              <Typography className={classes.label}>Subcategory</Typography>
              <SelectField
                ref={subcategoryRef}
                name="subcategory"
                items={getSubcategoryOptions(selectedCategory)}
                placeholder="Select Subcategory"
                value={selectedSubcategory || ''}
                onChange={handleSubcategoryChange}
              />
            </Box>
          )}
        </div>

        <div className={classes.buttonsContainer}>
          <Button variant="outlined" onClick={onCancel} className={classes.cancelButton}>
            Cancel
          </Button>
          <LoadingButton variant="contained" onClick={onSaveClick} loading={isSubmitting} className={classes.submitButton}>
            Save Changes
          </LoadingButton>
        </div>
      </div>
    </>
  );
};
export default EditCategoryForm;
